let instagram = document.querySelector('.instagramImages')

if (instagram){

  var instagram_count = 1;
  $(window).scroll(function() {
    if(elementVisible( $('.instagram') )){
      if(instagram_count === 1){
        instagram_count = 2;
        getInstagram();
      }
    }
  });
  function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
      visible = false;
    }
    return visible;
  }

  function getInstagram() {
    //return false;
    var token_instagram = 'IGQVJVZAUJid281dmxuaFJmVGk1WmE3U2hNY3JvNWxLRTZAmaldpTDRmMW54OVNVVmh4RmFEMGJnQU5pazN1MDlrNGJWOFNyRlJ5WUcyc2xyMnNRLUVUM3lUZADJnckFjWGFzbHNLWWFWcXp2TElvNDVZAbwZDZD';
    var URL_API_INSTAGRAM = "https://graph.instagram.com/me?fields=username,media&access_token="+token_instagram;
    $.getJSON(URL_API_INSTAGRAM, function (data) {
      var i = 1;
      var url_instagram = '';
      $('.instragramImages').html("");
      $.each(data.media.data, function (item, value) {
        if (i <= 6) {
          var MediaInstagram = "https://graph.instagram.com/"+value.id+"?fields=caption,media_url,media_type,id,permalink,thumbnail_url&access_token="+token_instagram;
          $.getJSON(MediaInstagram, function (data_media) {
            if(data_media.media_type === 'VIDEO'){
              url_instagram = data_media.thumbnail_url;
            }else{
              url_instagram = data_media.media_url;
            }
            $('.instagramImages').append('' +
              '                                <div class="inst">\n' +
              '                                    <a target="_blank" href="'+data_media.permalink+'">\n' +
              '                                        <div class="containerInstagram" >\n' +
              '                                            <div class="imgInsta" >\n' +
              '                                                <img src="'+url_instagram+'" alt="">\n' +
              '                                            </div>\n' +
              '                                        </div>\n' +
              '                                    </a>\n' +
              '                               </div>');
          });
        }
        i++;
      });
    });
  }
}
